module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"水災害発生リスクマップ","overview":"ゲリラ豪雨・集中豪雨時等に、気になる水災害発生リスク情報をリアルタイムにマップ上でご覧いただけます。"},"en":{"title":"Water-related disaster Risk Map","overview":"In case of extreme rain events, you can check out for the information on water-related disaster risk, real-time on the map."}}')
  delete Component.options._Ctor
}
